import header from './header';
import LinkListDropdowns from './LinkListDropdowns';
import Expander from './components/Expander';
import Tooltip from './components/Tooltip';
import GForms from './GForms';
import TableOfContents from './components/TableOfContents';
import EventSearch from './ACFO.EventSearch';

(function() {
function init() {
  setBodyWidth();
  
  header.init();
  LinkListDropdowns.init();
  Expander.init();
  GForms.init();
  EventSearch.init();
}

function setBodyWidth() {
  const fullWidth = document.body.clientWidth;
  document.documentElement.style.setProperty('--fullWidth', `${fullWidth}px`);
}

window.addEventListener('DOMContentLoaded', init);
window.addEventListener('resize', setBodyWidth);
window.addEventListener('load', setBodyWidth);
window.Tooltip = Tooltip;
window.ACFO = window.ACFO || {};
window.ACFO.GForms = GForms;
window.ACFO.TableOfContents = TableOfContents;

})();

